import { Link } from 'react-router-dom';
import { useLang } from '../i18n';
import { FALLBACK_IMAGE as FALLBACK } from '../lib/api';
import { Img } from './Img';

/** Tessera prodotto: nessun prezzo, nessun carrello. Solo il pezzo e la sua voce. */
export const ProductTile = ({ product, ratio = 'aspect-[4/5]', priority = false }) => {
  const { t } = useLang();
  const img = product.images?.[0] || FALLBACK;
  const label = product.collection || (product.category_label || product.category)?.toLowerCase();

  return (
    <Link
      to={`/prodotti/${product.slug}`}
      data-testid={`product-tile-${product.sku}`}
      className="group block"
    >
      <div className={`relative overflow-hidden bg-carta-2 ${ratio}`}>
        <Img
          src={img}
          alt={product.title}
          loading={priority ? 'eager' : 'lazy'}
          onError={(e) => {
            e.currentTarget.src = FALLBACK;
          }}
          className="img-zoom h-full w-full object-contain p-4 mix-blend-multiply md:p-7"
        />
        {product.shade && (
          <span className="absolute left-3 top-3 bg-carta px-2 py-1 text-[14px] text-inchiostro">
            {product.shade}
          </span>
        )}
      </div>
      <div className="pt-4">
        {label && (
          <p className="mb-1 text-[14px] text-marsala-dark">
            {label}
          </p>
        )}
        <h3 className="break-words font-display text-[18px] leading-snug transition-colors group-hover:text-marsala">
          {product.title.replace(/,\s*[^,]+$/, '').replace(/\//g, '/\u200b')}
        </h3>
        <p className="mt-1 text-[14px] text-inchiostro/65">
          {product.materials?.slice(0, 2).join(' · ') || t('common.sheet')}
        </p>
      </div>
    </Link>
  );
};

export const TileSkeleton = ({ ratio = 'aspect-[4/5]' }) => (
  <div>
    <div className={`bg-carta-2 ${ratio}`} />
    <div className="mt-4 h-2 w-16 bg-carta-3" />
    <div className="mt-3 h-4 w-3/4 bg-carta-2" />
  </div>
);
